import React from 'react';
import SidebarItem from './SidebarItemClient';
import data from '../Data/dataClient.json';
import Logo from '../Image/logo.png';
import { useSelector } from 'react-redux';

const SidebarClient = ({ hide, logout }) => {
    const client = useSelector((state) => state.client);
    return (
        <div className='sidebar d-flex flex-column h-100 justify-content-between'>
            <div className='bloc_sidebar'>
                <div className='bg-white pt-2'>
                    <div className='d-flex justify-content-end close_button'>
                        <i className='fa fa-close' onClick={() => hide()}></i>
                    </div>
                    <div className='d-flex justify-content-center '>
                        <div className='logo'>
                            <img src={Logo} alt='logo e-kaly' width="160px" height="57px" title="logo e-kaly" />
                        </div>
                    </div>
                </div>
                <div className='d-flex justify-content-center'>
                    <div className='description_client'>
                        <div className='d-flex justify-content-center'>
                            <div className='apropos'>
                                <div className='nom'>{client.nom} {client.prenom}</div>
                                <div className='client_telephone'>{client.telephone}</div>
                            </div>
                        </div>
                    </div>
                </div>
                {data.map((item, index) => <SidebarItem key={index} item={item} />)}
            </div>
            <div className='bloc_deconnection'>
                <div className='d-flex justify-content-center'>
                    <button className='btn' onClick={() => logout()}><i className='fa fa-power-off'></i>Je me déconnecte</button>
                </div>
            </div>
        </div>
    )
}

export default SidebarClient